import colorArray from "helpers/colorArray"
import { Pie } from "react-chartjs-2"
import _ from "lodash"

const lotTypes = (props, state) => {
	// State is from the weekly report, but props is used for widgets/elsewhere.
	let count = 0
	// First compile a list of all types
	let t = []
	let set
	if (_.isEmpty(state)) {
		set = {}
		set.sales = props.payload.sales.current
		set.bustouts = props.payload.bustouts.current
	} else {
		set = state
	}
	for (let v of set.sales) {
		t.push(v.lot_type)
		count++
	}
	for (let v of set.bustouts) {
		t.push(v.lot_type)
		count--
	}
	t = _.uniq(t)
	let types = {}
	for (let v of t) {
		let type = _.find(props.payload.public.lot_types, { id: v })
		if (type) {
			types[type.name] = 0
		}
	}

	for (let v of set.sales) {
		let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
		if (type) {
			types[type.name]++
		}
	}

	for (let v of set.bustouts) {
		let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
		if (type) {
			types[type.name]--
		}
	}
	let datasets = [
		{
			data: [],
			backgroundColor: [],
		},
	]
	let i = 0
	_.forEach(types, (v, k) => {
		let color
		let property
		if (_.get(props, `payload.activeProperties`)) {
			property = props.payload.activeProperties[0]
		} else property = props.activeProperties[0]
		let typeColorLookup = _.find(props.payload.public.lot_types, {
			name: k,
			property,
		})
		if (typeColorLookup && typeColorLookup.color) {
			color = typeColorLookup.color
		} else {
			color = colorArray[i]
		}
		i++
		datasets[0].data.push(v)
		datasets[0].backgroundColor.push(color)
	})
	const data = {
		labels: _.keys(types),
		datasets: datasets,
	}

	const opts = {
		legend: {
			display: true,
			position: "bottom",
		},
	}

	return (
		<>
			<h3 className="statBox__title">
				<span className="bug">YTD</span>Sales By Lot Type
			</h3>
			<p className="text-xs">Based on {count} sales.</p>
			<Pie data={data} options={opts} />
		</>
	)
}

export default lotTypes
